import Image from 'next/image'

import SeparatorImage from '@/images/separator.png'
import { formatUTCTime } from '@/lib/formatter'
import { Competition } from '@/redux/competition'

export interface RankingTitleProps {
  competition?: Competition
  className?: string
}

export default function RankingTitle({ competition, className }: RankingTitleProps) {
  const { title, applyStartAt, competitionEndAt } = competition || {
    title: 'Leaderboard',
  }
  return (
    <div className={className}>
      <div className="mb-4 font-bold text-center leading-16 text-5xl font-urbanist bg-gradient-to-r from-gradient-blue from-21% via-[#A7C1FF] via-48% to-gradient-blue to-79% bg-clip-text text-transparent">
        {title}
      </div>
      <div className="text-center text-xl font-semibold">
        {formatUTCTime('YYYY-MM-DD HH:mm')(applyStartAt)} (UTC)
        &nbsp;-&nbsp;
        {formatUTCTime('YYYY-MM-DD HH:mm')(competitionEndAt)} (UTC)
        <Image src={SeparatorImage} alt="" height={8} className="mx-auto mt-2" />
      </div>
    </div>
  )
}
